import { NO_INSURANCE_COMPANY, EXCLUDE_FILTER_KEYS } from "./utils/constanst";

const CONTAINS = "c";
const OPERATION_ONLY_FILTERS = ["missingFields", "audited"];

export const processFilters = (filter) => {
  const newObjFilter = Object.keys(filter)
    .map((key) => {
      const filterValue = filter[key];

      if (EXCLUDE_FILTER_KEYS.includes(key)) {
        return {
          [key]: filterValue,
        };
      }

      const isFilterObject =
        typeof filterValue === "object" &&
        filterValue !== null &&
        "operation" in filterValue &&
        "value" in filterValue;

      // Caso especial: patientId u otros valores simples
      if (!isFilterObject) {
        const hasValue =
          filterValue !== "" &&
          filterValue !== null &&
          filterValue !== undefined;

        return hasValue
          ? {
              [key]: filterValue,
            }
          : {};
      }

      const { operation, value } = filterValue;
      const isOperationOnlyFilter = OPERATION_ONLY_FILTERS.includes(key);

      // Remove filters that are inactive or have no value
      if (
        operation === "" ||
        (!isOperationOnlyFilter &&
          (value === "" || value === null || value === undefined))
      ) {
        return {};
      }

      return {
        [key]: {
          operation,
          value: changeValueByFilter(value, key),
        },
      };
    })
    .reduce((acc, current) => {
      return {
        ...acc,
        ...current,
      };
    }, {});

  return processMissingFields(newObjFilter);
};

const changeValueByFilter = (value, filter) => {
  return filter === "carrier" && value.toLowerCase() === NO_INSURANCE_COMPANY
    ? "EMPTY"
    : value;
};

const processMissingFields = (filters) => {
  const { missingFields = null, ...restFilters } = filters;
  const restFiltersCopy = { ...restFilters };

  if (missingFields?.operation) {
    restFiltersCopy["missingFields"] = missingFields.operation === CONTAINS;
  }
  processAuditProperty(restFiltersCopy);
  return restFiltersCopy;
};

export const processAuditProperty = (restFilters) => {
  if (restFilters["audited"]?.operation) {
    restFilters["audited"].value =
      restFilters["audited"].operation === CONTAINS;
    restFilters["audited"].operation = "c";
  }
};
